import { Component } from '@angular/core';

@Component({
  selector: 'lib-data-access',
  imports: [],
  templateUrl: './data-access.html',
  styleUrl: './data-access.css',
})
export class DataAccess {}
